/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import user from 'js/lib/user';

import { Typography } from '@coursera/cds-core';
import type { CalendarItem } from '@coursera/grpc-types-degreehome/coursera/proto/degreehome/v1beta1/calendar_item';

import Loader from 'bundles/degree-home/components/Loader';
import { WithGetDegreeHomeCalendarQuery } from 'bundles/degree-home/components/v2/Calendar';
import { RecentGradesItemsList } from 'bundles/degree-home/components/v2/RecentGrades/RecentGradesItemsList';
import { isStudentHomeV2Beta1Enabled } from 'bundles/degree-home/utils/experimentUtils';
import { Card } from 'bundles/program-loggedin-shared/components/Card';

import _t from 'i18n!nls/degree-home';

type CardProps = {
  degreeId: string;
};

type Props = {
  loading: boolean;
  data?: { GetDegreeHomeCalendar: { calendarItems: CalendarItem[] } };
  refetch: () => void;
};

export const RecentGradesCardContent: React.FunctionComponent<Props> = ({ loading, data, refetch }) => {
  return (
    <Card aria-label={_t('Recent Grades')} data-e2e="recent-grades-card">
      <Typography component="h2" variant="h2semibold" color="body">
        {_t('Recent Grades')}
      </Typography>
      {loading && <Loader />}
      {!loading && <RecentGradesItemsList data={data} refetch={refetch} />}
    </Card>
  );
};

export const RecentGradesCard: React.FunctionComponent<CardProps> = ({ degreeId }) => {
  return (
    <React.Fragment>
      {isStudentHomeV2Beta1Enabled() && (
        <WithGetDegreeHomeCalendarQuery userId={user.get().id} degreeId={degreeId}>
          {({ loading, data, refetch }) => {
            return <RecentGradesCardContent loading={loading} data={data} refetch={refetch} />;
          }}
        </WithGetDegreeHomeCalendarQuery>
      )}
    </React.Fragment>
  );
};

export default RecentGradesCard;
